const Range = require('../classes/range')

// Mostly just for testing and legacy API reasons
const toComparators = (range, options) =>
  new Range(range, options).set
    .map(comp => comp.map(c => c.value).join(' ').trim().split(' '))

module.exports = toComparators



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/ranges/to-comparators.js
// module id = 1938
// module chunks = 1